var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBookSetpoint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon book setpoint",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 42",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 31",
    d: "M.466 20.161A.463.463 0 0 1 0 19.7v-3.5a.456.456 0 0 1 .132-.319l6.515-6.57a6.725 6.725 0 0 1-.46-2.452 6.988 6.988 0 0 1 13.974 0 6.933 6.933 0 0 1-6.986 6.863 7.127 7.127 0 0 1-1.821-.236v1.692a.463.463 0 0 1-.466.458H8.16v2.288a.462.462 0 0 1-.466.457H4.38V19.7a.462.462 0 0 1-.465.457zm6.576-13.3a5.9 5.9 0 0 0 .4 2.151l.2.5-6.787 6.847v2.962h2.669v-1.776h3.781V14.8H10.5v-2.4l1.077.284a6.249 6.249 0 0 0 1.6.207 6.085 6.085 0 0 0 6.131-6.023 6.133 6.133 0 0 0-12.263 0zm-5.63 10.285v-.529L7.955 9.9a1.075 1.075 0 0 0 .461.427l-6.451 6.819zM11.777 6.341a2.329 2.329 0 1 1 2.328 2.288 2.311 2.311 0 0 1-2.328-2.288z",
    transform: "translate(1.919 1.919)",
    style: {
      fill: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBookSetpoint);
export default __webpack_public_path__ + "static/media/iconBookSetpoint.e2920f636754c33ebd7c6e5fd1c31722.svg";
export { ForwardRef as ReactComponent };